"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var prop_types_1 = __importDefault(require("prop-types"));
var React = __importStar(require("react"));
function Usage(_a) {
    var width = _a.width, height = _a.height, className = _a.className;
    return (React.createElement("svg", { className: "icon ".concat(className), height: "".concat(height), width: "".concat(width), viewBox: "0 0 52 46", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M-1.50866e-06 3.81782L-1.54123e-07 34.8061C-6.87367e-08 36.7595 1.58016 38.332 3.53204 38.332L48.4695 38.332C50.4152 38.332 52 36.7595 52 34.8061L52 3.81782C52 1.87053 50.4168 0.290373 48.4695 0.290373L3.53203 0.290375C1.58016 0.287315 -1.59385e-06 1.86901 -1.50866e-06 3.81782ZM50.6768 19.3104C50.6768 20.4699 49.7391 21.4076 48.5812 21.4076C47.4217 21.4076 46.4824 20.4699 46.4824 19.3104C46.4824 18.154 47.4217 17.2132 48.5812 17.2132C49.7391 17.2132 50.6768 18.154 50.6768 19.3104ZM45.6453 3.85912L45.6453 34.7618L3.24334 34.7618L3.24334 3.85912L45.6453 3.85912Z", fill: "white" }),
        React.createElement("path", { d: "M35.351 23.2586H35.175C34.151 23.2586 33.3171 24.0906 33.3171 25.1126V26.7706H33.0891V25.1126C33.0891 24.0896 32.253 23.2586 31.233 23.2586H31.051C30.03 23.2586 29.197 24.0906 29.197 25.1126V26.7706H28.967V25.1126C28.967 24.0896 28.133 23.2586 27.113 23.2586H26.929C25.909 23.2586 25.075 24.0906 25.075 25.1126V26.7706H24.9541V16.1766C24.9541 15.1476 24.121 14.3106 23.088 14.3106L22.907 14.3096C21.88 14.3096 21.0441 15.1466 21.0441 16.1766V32.3856C20.5461 31.8236 20.1081 31.2506 19.7071 30.7336C18.8151 29.5796 18.114 28.6656 17.322 28.4836C16.443 28.2746 15.631 28.5676 15.24 29.2016C14.873 29.8046 14.929 30.6346 15.393 31.5346C16.409 33.4776 21.29 42.0136 21.293 42.0136C21.679 42.9476 23.3821 45.9996 29.1161 45.9996V45.7956L29.1221 45.9996C33.2921 45.9996 35.267 44.0316 36.19 42.3816C37.186 40.5996 37.202 38.8436 37.202 38.7676V25.1126C37.206 24.0886 36.369 23.2586 35.351 23.2586Z", fill: "white" })));
}
Usage.propTypes = {
    width: prop_types_1.default.number,
    height: prop_types_1.default.number,
    className: prop_types_1.default.string,
};
exports.default = Usage;
